/* globals global */
import Backbone from 'backbone';

global.EasyPost = global.EasyPost || {};

export default Backbone.View.extend({
  template(context = {}) {
    if (!this.compiledTemplate) {
      throw new Error('No View.compiledTemplate defined');
    }

    return this.compiledTemplate(context);
  },

  context() {
    return {};
  },

  beforeRender() {},
  afterRender() {},
  onDomRefresh() {},
  onDomRefreshBase() {
    // run onDomRefresh for main view
    this.onDomRefresh();

    // run it for subviews
    this.ensureSubviews();
    Object.keys(this._subviews).forEach(name => this._subviews[name].instance.onDomRefresh());
  },

  render() {
    this.beforeRender();

    this.$el.html(this.template(this.context()));
    this.renderSubviews();
    this.afterRender();
    return this;
  },

  ensureSubviews() {
    if (!this._subviews) { this._subviews = {}; }
  },

  addSubview(name, selector, instance) {
    this.ensureSubviews();

    if (this.getSubview(name)) {
      this.removeSubview(name);
    }
    this._subviews[name] = { selector, instance };
  },

  getSubview(name) {
    this.ensureSubviews();
    const subview = this._subviews[name];
    return subview ? subview.instance : undefined;
  },

  renderSubviews() {
    this.ensureSubviews();
    Object.keys(this._subviews).forEach((name) => {
      const structure = this._subviews[name];
      structure.instance.setElement(this.$(structure.selector));
      structure.instance.render();
    });
  },

  removeSubviews() {
    this.ensureSubviews();
    Object.keys(this._subviews).forEach(name => this.removeSubview(name));
  },

  removeSubview(name) {
    const subview = this.getSubview(name);
    if (subview) {
      subview.removeSubviews();
      subview.remove();
      subview.unbind();
      delete this._subviews[name];
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/base.js